var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPartners = function SvgIconPartners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#icon-partners_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.834 8.441-11.9 6.442V2zm-2.1 0-8.8-4.763v9.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.85,
    d: "M2.166 8.442 14.066 2v12.883zm2.1 0 8.8 4.763V3.678z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-partners_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgIconPartners as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIzMV8xODYpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy44MzQgOC40NDE0OUwxLjkzMzE5IDE0Ljg4M0wxLjkzMzE5IDJMMTMuODM0IDguNDQxNDlaTTExLjczMzIgOC40NDE0OUwyLjkzMzE5IDMuNjc4MzVMMi45MzMxOSAxMy4yMDQ2TDExLjczMzIgOC40NDE0OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuMTY1NTMgOC40NDE1TDE0LjA2NjMgMi4wMDAwMUwxNC4wNjYzIDE0Ljg4M0wyLjE2NTUzIDguNDQxNVpNNC4yNjYzMiA4LjQ0MTVMMTMuMDY2MyAxMy4yMDQ2TDEzLjA2NjMgMy42NzgzNkw0LjI2NjMyIDguNDQxNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjg1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjMxXzE4NiI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";